(()=>{
const target=document.querySelector('[data-on-home-catalog]');if(!target)return;
async function sync(){try{
 const url=new URL(target.dataset.homeUrl,location.origin);
 const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
 const response=await fetch(url,{credentials:'same-origin',cache:'no-store'});if(!response.ok)throw Error('Homepage unavailable');
 const source=new DOMParser().parseFromString(await response.text(),'text/html');
 const isCollections=target.dataset.catalogKind==='collections';
 const selector=isCollections?'.on-collections .on-collection-card':'[data-offnote-home] .on-moods .on-grid > .on-card';
 const cards=[...source.querySelectorAll(selector)];if(!cards.length)return;
 const grid=target.querySelector('[data-on-catalog-grid]');
 for(const card of cards){card.hidden=false;card.querySelectorAll('[data-ready]').forEach(el=>el.removeAttribute('data-ready'));grid.append(document.importNode(card,true))}
 target.querySelector('[data-on-catalog-count]').textContent=cards.length+(isCollections?' collections':' products in the homepage edit');
 document.querySelector('[data-on-native-catalog]').hidden=true;target.hidden=false;
 document.dispatchEvent(new CustomEvent('shopify:section:load',{bubbles:true}));
 }catch(error){/* Keep the server-rendered, usable Shopify catalog on load failure. */}}
sync();})();
